import React, { useState, useEffect } from 'react';

export const loader = ({ getComponent, Fallback }) => {
  const Loader = props => {
    const [Component, setComponent] = useState(() => Fallback);

    useEffect(() => {
      getComponent(props).then(LoadedComponent => {
        setComponent(() => LoadedComponent);
      });
    }, []);

    return <Component {...props} />;
  };
  return Loader;
};
